import { resolveExpectedStorefrontConfigIdentity } from './storefront-config-identity'

export const STOREFRONT_RUNTIME_IDENTITY = (() => {
  try {
    return resolveExpectedStorefrontConfigIdentity()
  } catch {
    return null
  }
})()

export const LOJA_VIRTUAL_DEFAULT_LOJA_ID = STOREFRONT_RUNTIME_IDENTITY
  ? String(STOREFRONT_RUNTIME_IDENTITY.lojaId)
  : ''

export function getLojaVirtualDefaultLojaId(): number | undefined {
  const lojaId = Number.parseInt(LOJA_VIRTUAL_DEFAULT_LOJA_ID, 10)
  return Number.isFinite(lojaId) && lojaId > 0 ? lojaId : undefined
}
